import { useMutation } from "@apollo/client";
import { useCallback, useState } from "react";

import { PlannerV2_GetPendingChangesDocument } from "../../queries.generated";
import { PlannerV2TravelGroupCancelShiftDocument } from "../mutations.generated";
import { PlannerV2FieldworkersGetPlannableForVisitDocument, PlannerV2VisitGetByIdDocument } from "../queries.generated";

export default function usePlannerV2TravelGroupCancelShift() {
    const [isCancelingShiftId, setIsCancelingShiftId] = useState<string | undefined>(undefined);
    const [mutate, { data, loading, error }] = useMutation(PlannerV2TravelGroupCancelShiftDocument, {
        refetchQueries: [
            PlannerV2VisitGetByIdDocument,
            PlannerV2FieldworkersGetPlannableForVisitDocument,
            PlannerV2_GetPendingChangesDocument,
        ],
        awaitRefetchQueries: true,
    });

    const cancelShiftInTravelGroup = useCallback(
        async ({ shiftId, travelGroupId }: { shiftId: string; travelGroupId: string }) => {
            setIsCancelingShiftId(shiftId);
            try {
                await mutate({
                    variables: {
                        input: {
                            plannerShiftId: shiftId,
                            plannerTravelGroupId: travelGroupId,
                        },
                    },
                });
            } finally {
                setIsCancelingShiftId(undefined);
            }
        },
        [mutate],
    );

    return {
        cancelShiftInTravelGroup,
        loading,
        isCancelingShiftId,
        error,
        data,
    };
}
